<template>
    <div class="layout-menu-container">
        <AppSubmenu
            class="layout-menu"
            :items="filteredMenuItems"
            :menuMode="menuMode"
            :parentMenuItemActive="true"
            :menuActive="active"
            :mobileMenuActive="mobileMenuActive"
            :root="true"
            @menuitem-click="onMenuItemClick"
            @root-menuitem-click="onRootMenuItemClick"
        />
    </div>
</template>

<script>
import AppSubmenu from '@/components/AppSubmenu';
import { useMenu } from '@/composables/MenuComposable';
export default {
    name: 'AppMenu',
    components: {
        AppSubmenu: AppSubmenu,
    },
    emits: ['menuitem-click', 'root-menuitem-click'],
    props: {
        menuMode: String,
        active: Boolean,
        mobileMenuActive: Boolean,
    },
    setup() {
        const { filteredMenuItems } = useMenu();
        return { filteredMenuItems };
    },
    methods: {
        onMenuItemClick(event) {
            this.$emit('menuitem-click', event);
        },
        onRootMenuItemClick(event) {
            this.$emit('root-menuitem-click', event);
        },
    },
};
</script>
